import BaseClient from '@/app/model/api/response/baseApiClient'

class NewsBoardContentDeleteApi extends BaseClient {
  public doNewsBoardContentDelete (id: string) {
    const path: string = '/v1/news-board-contents/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new NewsBoardContentDeleteApi()
